var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconListLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 144,
    viewBox: "0 0 280 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35868_15899)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_35868_15899",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 -21.1758H250V46.388H31V-21.1758Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31 -21.1758H250V46.388H31V-21.1758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 45.7472H31V47.0289H250V45.7472Z",
    fill: "#DEE4ED",
    mask: "url(#path-1-inside-1_35868_15899)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_35868_15899)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.1828,
    cy: 4.51271,
    r: 19.1182,
    fill: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7511 14.3133C39.7992 16.6104 40.13 19.7674 42.7157 20.5972C43.4571 20.7743 44.2276 20.7927 44.9767 20.6513C45.6553 20.5946 46.3374 20.7083 46.961 20.982C48.3621 21.5353 49.6189 22.2208 51.1703 22.2689C52.6735 22.2975 54.1471 21.8491 55.3796 20.9881C55.8186 20.6934 56.474 20.068 57.0573 20.1282C57.6406 20.1883 58.1457 20.7295 58.6568 20.9339C61.7777 22.1907 63.1247 18.4084 63.3592 16.0572C63.8884 10.6452 60.9539 5.28742 57.1415 1.62534V1.58325C57.3178 1.11986 57.4134 0.629707 57.4241 0.134048C57.5167 -0.575739 57.6716 -1.27599 57.8871 -1.95857C58.272 -3.07102 59.2161 -3.89484 59.8535 -4.86298C60.4436 -5.71449 60.7315 -6.73913 60.6713 -7.7734C60.6521 -8.2386 60.5287 -8.69356 60.3101 -9.10467C60.0915 -9.51578 59.7834 -9.87255 59.4085 -10.1486C58.5065 -10.75 57.37 -10.6658 56.3297 -10.6838C54.183 -10.7199 51.8919 -10.9604 49.7873 -10.4313C48.7835 -10.1873 47.8613 -9.6839 47.1131 -8.97158C46.3649 -8.25926 45.8169 -7.36294 45.5239 -6.37231C44.9225 -4.47813 44.658 -1.85634 45.4637 0.00175571L45.2052 0.164114C44.6088 0.556847 44.0546 1.01026 43.5515 1.5171C42.6257 2.49306 41.8696 3.61701 41.3146 4.84243C39.9616 7.82501 39.709 11.0962 39.7511 14.3133Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7761 -4.18359C55.7761 -4.18359 56.6901 2.431 53.6774 3.42319C51.2721 4.21694 48.8127 2.13635 48.1753 -2.09098",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5203 22.2753C44.5203 22.2753 39.5954 7.30824 48.1643 3.42969",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6902 4.52344C59.3601 6.21918 62.5892 10.5367 60.7672 21.5951",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1397 13.7183C58.1397 13.7183 59.3423 20.3329 51.5251 20.3329C49.1679 20.3329 47.2376 20.1404 46.5281 12.5156",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9911 -0.285567C46.2394 -1.02829 45.7532 -1.99786 45.6075 -3.0445C45.4619 -4.09114 45.6649 -5.15661 46.1853 -6.07634C45.7229 -6.20574 45.3068 -6.46397 44.9857 -6.82089C44.6645 -7.17781 44.4514 -7.61872 44.3714 -8.09215C44.2913 -8.56558 44.3475 -9.05202 44.5335 -9.49471C44.7195 -9.93739 45.0275 -10.3181 45.4216 -10.5923C48.0434 -12.3963 49.216 -8.0066 49.216 -8.0066C52.7458 -10.6043 56.2274 -9.75045 55.9208 -7.03847C55.5059 -3.33429 50.0218 -4.90376 50.0218 -4.90376C49.8579 -4.46381 49.5618 -4.08541 49.1741 -3.82054C48.7865 -3.55566 48.3264 -3.41731 47.857 -3.42449",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.0676,
    y: -4.44531,
    width: 40.6261,
    height: 5.37699,
    rx: 2.68849,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0674,
    y: 19.0352,
    width: 158.322,
    height: 3.58466,
    rx: 1.79233,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0674,
    y: 25.0117,
    width: 158.322,
    height: 3.58466,
    rx: 1.79233,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0674,
    y: 30.9844,
    width: 46.0031,
    height: 3.58466,
    rx: 1.79233,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.0632,
    y: 19.0352,
    width: 38.2364,
    height: 3.58466,
    rx: 1.79233,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-2_35868_15899",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 52.2109H250V119.775H31V52.2109Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31 52.2109H250V119.775H31V52.2109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 119.134H31V120.416H250V119.134Z",
    fill: "#DEE4ED",
    mask: "url(#path-16-inside-2_35868_15899)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_35868_15899)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.1828,
    cy: 77.8994,
    r: 19.1182,
    fill: "#8A75F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7511 87.7C39.7992 89.9971 40.13 93.1541 42.7157 93.9839C43.4571 94.161 44.2276 94.1794 44.9767 94.038C45.6553 93.9813 46.3374 94.095 46.961 94.3688C48.3621 94.922 49.6189 95.6075 51.1703 95.6556C52.6735 95.6842 54.1471 95.2358 55.3796 94.3748C55.8186 94.0801 56.474 93.4547 57.0573 93.5149C57.6406 93.575 58.1457 94.1162 58.6568 94.3207C61.7777 95.5774 63.1247 91.7951 63.3592 89.4439C63.8884 84.032 60.9539 78.6741 57.1415 75.0121V74.97C57.3178 74.5066 57.4134 74.0164 57.4241 73.5208C57.5167 72.811 57.6716 72.1107 57.8871 71.4282C58.272 70.3157 59.2161 69.4919 59.8535 68.5237C60.4436 67.6722 60.7315 66.6476 60.6713 65.6133C60.6521 65.1481 60.5287 64.6932 60.3101 64.282C60.0915 63.8709 59.7834 63.5142 59.4085 63.2381C58.5065 62.6368 57.37 62.7209 56.3297 62.7029C54.183 62.6668 51.8919 62.4263 49.7873 62.9555C48.7835 63.1995 47.8613 63.7028 47.1131 64.4151C46.3649 65.1275 45.8169 66.0238 45.5239 67.0144C44.9225 68.9086 44.658 71.5304 45.4637 73.3885L45.2052 73.5508C44.6088 73.9436 44.0546 74.397 43.5515 74.9038C42.6257 75.8798 41.8696 77.0037 41.3146 78.2292C39.9616 81.2117 39.709 84.483 39.7511 87.7Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7761 69.2031C55.7761 69.2031 56.6901 75.8177 53.6774 76.8099C51.2721 77.6037 48.8127 75.5231 48.1753 71.2957",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5203 95.662C44.5203 95.662 39.5954 80.695 48.1643 76.8164",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6902 77.9102C59.3601 79.6059 62.5892 83.9234 60.7672 94.9818",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1397 87.105C58.1397 87.105 59.3423 93.7196 51.5251 93.7196C49.1679 93.7196 47.2376 93.5272 46.5281 85.9023",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9911 73.1012C46.2394 72.3584 45.7532 71.3889 45.6075 70.3422C45.4619 69.2956 45.6649 68.2301 46.1853 67.3104C45.7229 67.181 45.3068 66.9228 44.9857 66.5658C44.6645 66.2089 44.4514 65.768 44.3714 65.2946C44.2913 64.8211 44.3475 64.3347 44.5335 63.892C44.7195 63.4493 45.0275 63.0687 45.4216 62.7944C48.0434 60.9904 49.216 65.3801 49.216 65.3801C52.7458 62.7824 56.2274 63.6363 55.9208 66.3483C55.5059 70.0524 50.0218 68.483 50.0218 68.483C49.8579 68.9229 49.5618 69.3013 49.1741 69.5662C48.7865 69.8311 48.3264 69.9694 47.857 69.9622",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.0676,
    y: 58.7812,
    width: 56.7571,
    height: 5.37699,
    rx: 2.68849,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.409,
    y: 58.7812,
    width: 5.37699,
    height: 5.37699,
    rx: 2.68849,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.177,
    y: 58.7812,
    width: 5.37699,
    height: 5.37699,
    rx: 2.68849,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0676,
    y: 68.9414,
    width: 40.6261,
    height: 5.37699,
    rx: 2.68849,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0674,
    y: 92.418,
    width: 158.322,
    height: 3.58466,
    rx: 1.79233,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0674,
    y: 98.3945,
    width: 158.322,
    height: 3.58466,
    rx: 1.79233,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0674,
    y: 104.367,
    width: 46.0031,
    height: 3.58466,
    rx: 1.79233,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.0634,
    y: 92.418,
    width: 38.2364,
    height: 3.58466,
    rx: 1.79233,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-34-inside-3_35868_15899",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 124.438H250V192.001H31V124.438Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31 124.438H250V192.001H31V124.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 191.361H31V192.642H250V191.361Z",
    fill: "#DEE4ED",
    mask: "url(#path-34-inside-3_35868_15899)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_35868_15899)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.1828,
    cy: 150.126,
    r: 19.1182,
    fill: "#FF44FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7511 159.927C39.7992 162.224 40.13 165.381 42.7157 166.21C43.4571 166.388 44.2276 166.406 44.9767 166.265C45.6553 166.208 46.3374 166.322 46.961 166.595C48.3621 167.149 49.6189 167.834 51.1703 167.882C52.6735 167.911 54.1471 167.462 55.3796 166.601C55.8186 166.307 56.474 165.681 57.0573 165.741C57.6406 165.802 58.1457 166.343 58.6568 166.547C61.7777 167.804 63.1247 164.022 63.3592 161.67C63.8884 156.259 60.9539 150.901 57.1415 147.239V147.197C57.3178 146.733 57.4134 146.243 57.4241 145.747C57.5167 145.038 57.6716 144.337 57.8871 143.655C58.272 142.542 59.2161 141.718 59.8535 140.75C60.4436 139.899 60.7315 138.874 60.6713 137.84C60.6521 137.375 60.5287 136.92 60.3101 136.509C60.0915 136.097 59.7834 135.741 59.4085 135.465C58.5065 134.863 57.37 134.948 56.3297 134.929C54.183 134.893 51.8919 134.653 49.7873 135.182C48.7835 135.426 47.8613 135.929 47.1131 136.642C46.3649 137.354 45.8169 138.25 45.5239 139.241C44.9225 141.135 44.658 143.757 45.4637 145.615L45.2052 145.777C44.6088 146.17 44.0546 146.624 43.5515 147.13C42.6257 148.106 41.8696 149.23 41.3146 150.456C39.9616 153.438 39.709 156.71 39.7511 159.927Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7761 141.43C55.7761 141.43 56.6901 148.044 53.6774 149.036C51.2721 149.83 48.8127 147.75 48.1753 143.522",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9911 145.328C46.2394 144.585 45.7532 143.615 45.6075 142.569C45.4619 141.522 45.6649 140.457 46.1853 139.537C45.7229 139.408 45.3068 139.149 44.9857 138.792C44.6645 138.435 44.4514 137.995 44.3714 137.521C44.2913 137.048 44.3475 136.561 44.5335 136.119C44.7195 135.676 45.0275 135.295 45.4216 135.021C48.0434 133.217 49.216 137.607 49.216 137.607C52.7458 135.009 56.2274 135.863 55.9208 138.575C55.5059 142.279 50.0218 140.71 50.0218 140.71C49.8579 141.149 49.5618 141.528 49.1741 141.793C48.7865 142.058 48.3264 142.196 47.857 142.189",
    stroke: "#00005A",
    strokeWidth: 0.896165,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.0676,
    y: 131.008,
    width: 56.7571,
    height: 5.37699,
    rx: 2.68849,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.409,
    y: 131.008,
    width: 5.37699,
    height: 5.37699,
    rx: 2.68849,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.177,
    y: 131.008,
    width: 5.37699,
    height: 5.37699,
    rx: 2.68849,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0676,
    y: 141.164,
    width: 40.6261,
    height: 5.37699,
    rx: 2.68849,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 281,
    height: 24,
    fill: "url(#paint0_linear_35868_15899)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 24,
    transform: "matrix(1 0 0 -1 -1 144)",
    fill: "url(#paint1_linear_35868_15899)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35868_15899",
    x1: 134.5,
    y1: 3.07186e-7,
    x2: 134.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35868_15899",
    x1: 135.5,
    y1: 3.07186e-7,
    x2: 135.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35868_15899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 144,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_35868_15899"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.0645,
    y: -14.6055,
    width: 28.6214,
    height: 28.6214,
    rx: 14.3107,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_35868_15899"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.0645,
    y: 58.7812,
    width: 28.6214,
    height: 28.6214,
    rx: 14.3107,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_35868_15899"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.0645,
    y: 131.008,
    width: 28.6214,
    height: 28.6214,
    rx: 14.3107,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListLoading);
export default __webpack_public_path__ + "static/media/icon-list-loading.f5982c6fda28ecba36285d7e5db1a5a5.svg";
export { ForwardRef as ReactComponent };